import { render, staticRenderFns } from "./EditFocus.vue?vue&type=template&id=5b6ddc98&scoped=true&"
import script from "./EditFocus.vue?vue&type=script&lang=js&"
export * from "./EditFocus.vue?vue&type=script&lang=js&"
import style0 from "./EditFocus.vue?vue&type=style&index=0&id=5b6ddc98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ddc98",
  null
  
)

export default component.exports